import axios from 'axios';
import router from '../router/index.js';
import store from '../store/index';
// import encryptAjaxParams from '../util/encrypt';
import {Message, Loading} from 'element-ui';
import {getSafeLocation, readCookie} from '../util/safe';
import {getRequestParams, getParams} from '../util/util';
import {getRootPath} from '../util/util';

let ajaxCfg = window.Config.ajax,
    csrf = window.Config.csrf,
    isMock = window.Config.isMock,
    domain = isMock ? 'https://fe.epoint.com.cn/mock/1346/' : window.Config.domain,
    service = window.service, // 获取静态资源 public/Config.js 中的接口配置
    instance;

// 创建 axios 实例
instance = axios.create({
    timeout: ajaxCfg.timeout,
    withCredentials: !!ajaxCfg.withCredentials,
    headers: {
        'Content-Type': isMock ? 'application/x-www-form-urlencoded' : 'application/json'
    }
});

const Request = {};

// 请求格式/参数的统一
// 循环遍历 service 输出请求方法
for (let key in service) {
    let api = service[key]; // url & method

    if (typeof api === 'string') {
        api = {
            url: api,
            method: 'post'
        };
    }
    api.url = (api.baseUrl ? api.baseUrl : domain) + api.url;

    Request[key] = function (
        params, // 请求参数 get：(url)，put，post，patch（url, data），delete：(url)
        config = {} // 配置参数
    ) {
        params = getRequestParams(params);
        // 不同类型请求的判断
        let response = {};
        if (api.method === 'put' || api.method === 'post' || api.method === 'patch') {
            response = instance[api.method](api.url, params, config);
        } else if (api.method === 'delete' || api.method === 'get') {
            config.params = params; // 拼接在url上的参数
            response = instance[api.method](api.url, config);
        }

        return response;
    };
}

// 处理请求和响应错误
function handleStatusCode(error) {
    let data = error.response,
        status;

    let showMessage = function (msg) {
        let errorText = '',
            stack = '';

        // 响应错误
        if (data) {
            errorText = msg ? msg : data.statusText;
            stack = data.stackError ? data.stackError : '';
            errorText += stack;
        }
        // 请求错误
        else {
            errorText = msg ? msg : error.message;
        }

        if (errorText) {
            Message({
                message: errorText,
                type: 'error',
                duration: 3000
            });
        }
    };

    if (data) {
        status = data.status;

        switch (status) {
            // 安全框架拦截
            case 400:
                showMessage();
                break;

            // 未登录的权限拦截
            case 401:
                let url = '';

                // 如果返回数据中带了url，直接跳转到返回的 url 页面
                if (data && (url = data.url)) {
                    if (url.indexOf('http') !== 0) {
                        url = getRootPath() + url;
                    }
                    getSafeLocation().setHref(url);
                    return;
                }

                // 前端处理跳转登录页
                if (router) {
                    router.push('/login');
                    return;
                }

                break;

            // 功能权限拦截
            case 403:
                showMessage();
                break;

            // 404拦截
            case 404:
                break;

            // 报错类拦截
            case 500:
                showMessage();
                break;

            // 用于被安全模块拦截后返回503的处理
            case 503:
                showMessage('服务不可用');
                break;

            default:
                showMessage();
        }
    } else {
        //
    }
}

// 请求loading实例
let loadingInstance = {};

// 取消遮罩
function clearLoading(config) {
    if (loadingInstance[config.url]) {
        loadingInstance[config.url].close();
        loadingInstance[config.url] = null;
    }
}

// 拦截器的添加-请求拦截器
instance.interceptors.request.use(
    (config) => {
        // 如果需要页面层级遮罩，加上遮罩,loadingTarget 配置遮罩目标元素
        if (config.showLoading && !loadingInstance[config.url]) {
            loadingInstance[config.url] = Loading.service({
                fullscreen: config.loadingTarget ? false : true,
                target: config.loadingTarget ? config.loadingTarget : document.body,
                background: 'rgba(0, 0, 0, 0.7)'
            });
        }

        // 对csrf防御处理
        if (csrf.open) {
            let csrfcookie = readCookie(csrf.CSRF_COOKIE_NAME || '_CSRFCOOKIE');
            if (csrfcookie) {
                config.headers[csrf.CSRF_HD_NAME || 'CSRFCOOKIE'] = csrfcookie;
            }
        }

        // let encryptData;
        // 如果需要加密，替换为加密格式
        if (store.getters.sysParams.securityUrlparamEncodeEnable && config.data) {
            let params = getParams(config.data);
            config.data = params;
        }
        return config;
    },
    (error) => {
        handleStatusCode(error);
        clearLoading(error.config);
        return Promise.reject(error);
    }
);

// 拦截器的添加-响应拦截器
instance.interceptors.response.use(
    (res) => {
        clearLoading(res.config);

        let data = res.data;

        if (data.code != 200 && data.code != 1) {
            Message({
                message: data.msg,
                type: 'error',
                duration: 3000
            });
            return Promise.reject(data);
        }

        // // 统一处理 status 字段信息， 即业务处理的状态信息
        // let status = res.data.status;
        // if (status) {
        // let code = parseInt(status.code),
        // text = status.text || '',
        // url = status.url,
        // tipTxt = code === 1 || code === 200 ? '成功' : '失败',
        // tipType = code === 1 || code === 200 ? 'success' : 'error';

        // // 返回重定向地址
        // if (url) {
        // if (url.indexOf('http') !== 0) {
        // url = getRootPath() + url;
        // }
        // getSafeLocation().setHref(url);
        // return;
        // }

        // // 弹出业务处理的状态描述文字
        // if (text) {
        // Message({
        // message: tipTxt + '：' + text,
        // type: tipType,
        // duration: 3000
        // });
        // }
        // }

        return data.data;
    },
    (error) => {
        handleStatusCode(error);
        clearLoading(error.config);
        return Promise.reject(error);
    }
);

export default Request;
